import { loadComponent } from '../../_Utils/routeComponent';

export default [
  {
    i: 'MentionPreviewPerEmotions',
    component: 'MentionPreviewPerEmotions',
    data: {
      title: 'Mention preview per emotions',
      titleSecondPart: '',
      dropDownOptions: ['EXPORT'],
    },
    breakpoints: {
      xl: {
        w: loadComponent('MentionPreviewPerEmotions', 'breakpoints').lg.w,
        h: loadComponent('MentionPreviewPerEmotions', 'breakpoints').lg.h,
        minW: loadComponent('MentionPreviewPerEmotions', 'breakpoints').lg.minW,
        minH: loadComponent('MentionPreviewPerEmotions', 'breakpoints').lg.minH,
        x: 0,
        y: 0,
      },
      lg: {
        w: loadComponent('MentionPreviewPerEmotions', 'breakpoints').lg.w,
        h: loadComponent('MentionPreviewPerEmotions', 'breakpoints').lg.h,
        minW: loadComponent('MentionPreviewPerEmotions', 'breakpoints').lg.minW,
        minH: loadComponent('MentionPreviewPerEmotions', 'breakpoints').lg.minH,
        x: 0,
        y: 0,
      },
      md: {
        w: loadComponent('MentionPreviewPerEmotions', 'breakpoints').md.w,
        h: loadComponent('MentionPreviewPerEmotions', 'breakpoints').md.h,
        minW: loadComponent('MentionPreviewPerEmotions', 'breakpoints').md.minW,
        minH: loadComponent('MentionPreviewPerEmotions', 'breakpoints').md.minH,
        x: 0,
        y: 0,
      },
      sm: {
        w: loadComponent('MentionPreviewPerEmotions', 'breakpoints').sm.w,
        h: loadComponent('MentionPreviewPerEmotions', 'breakpoints').sm.h,
        minW: loadComponent('MentionPreviewPerEmotions', 'breakpoints').sm.minW,
        minH: loadComponent('MentionPreviewPerEmotions', 'breakpoints').sm.minH,
        x: 0,
        y: 0,
      },
      xs: {
        w: loadComponent('MentionPreviewPerEmotions', 'breakpoints').xs.w,
        h: loadComponent('MentionPreviewPerEmotions', 'breakpoints').xs.h,
        minW: loadComponent('MentionPreviewPerEmotions', 'breakpoints').xs.minW,
        minH: loadComponent('MentionPreviewPerEmotions', 'breakpoints').xs.minH,
        x: 0,
        y: 0,
      },
    },
  },
];
